import React, { useState } from 'react';

import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import useI18n from 'Hooks/useI18n';

import * as actions from '../../actions';
import { useDispatch, useSelector } from '../../Hooks';
import Loader from '../Loader';
import SideModal from '../SideModal';
// import { deleteNode } from '../../Scenes-redesign/PIM/__queries__';
import { DeleteModificationGroup, DeleteModificationGroupVariables } from './__queries__';
import { LoaderWrapper } from './styles';
import ModalHeader from '../SideModal/Header';

// const DUPLICATE_NODE = gql`
//   mutation duplicateNode($id: ID!) {
//     result: duplicateNode(id: $id) {
//       success
//       message
//     }
//   }
// `;

export const DELETE_MODIFICATION_GROUP = gql`
  mutation DeleteModificationGroup($input: DeleteModificationGroupInput!) {
    deleteModificationGroup(input: $input) {
      success
      error
      message
    }
  }
`;

const DELETE_NODE = gql`
  mutation deleteNode($id: ID!) {
    result: deleteNode(id: $id) {
      success
      message
    }
  }
`;

interface Props {
  closeModal: () => void;
  onSuccess?: () => void;
  children: React.ReactElement;
  title: string;
  description?: string;
  idToUpdate?: string;
  showUnsavedChangesQuestionModal?: boolean;
  isModificationGroup?: boolean;
}

const FormWrapper = ({
  closeModal,
  onSuccess,
  children,
  title,
  description,
  idToUpdate,
  showUnsavedChangesQuestionModal,
  isModificationGroup,
}: Props) => {
  const [loading, setLoading] = useState(false);
  // const [duplicateItem] = useMutation(DUPLICATE_NODE);
  const [deleteModificationGroup] = useMutation<
    DeleteModificationGroup,
    DeleteModificationGroupVariables
  >(DELETE_MODIFICATION_GROUP);
  const [deleteItem] = useMutation<any>(DELETE_NODE);
  const dispatch = useDispatch();
  const { t } = useI18n();

  const copyHandler = async () => {
    return null;
    // try {
    //   setLoading(true);
    //   await duplicateItem({
    //     variables: {
    //       id: nodeId,
    //     },
    //   });
    //   dispatch(actions.showNotice(`${title} was copied`));
    //   setLoading(false);
    // } catch (e) {
    //   dispatch(actions.showNotice('Error'));
    //   console.log(`e`, e);
    // }
    // closeModal();
  };

  const deleteModificationGroupHandler = async () => {
    if (!idToUpdate) return;

    try {
      setLoading(true);
      const deletedItem = await deleteModificationGroup({
        variables: {
          input: {
            id: idToUpdate?.replace('modification-group-', ''),
          },
        },
      });

      if (deletedItem?.data?.deleteModificationGroup.success) {
        dispatch(actions.showNotice(`${title} was deleted`, 4000));
        onSuccess && onSuccess();
        closeModal();
      } else if (deletedItem?.data?.deleteModificationGroup.message) {
        dispatch(actions.showNotice(deletedItem?.data?.deleteModificationGroup.message, 4000));
      }
      setLoading(false);
    } catch (e) {
      dispatch(actions.showNotice('Error', 4000));
    }
  };

  const deleteHandler = async () => {
    try {
      setLoading(true);
      const deletedItem = await deleteItem({
        variables: {
          id: idToUpdate?.replace('group-', ''),
        },
      });

      if (deletedItem?.data?.result?.success) {
        dispatch(actions.showNotice(`${title} was deleted`, 4000));
        onSuccess && onSuccess();
        closeModal();
      } else if (deletedItem?.data?.result?.message) {
        dispatch(actions.showNotice(deletedItem?.data?.result?.message, 4000));
      }
      setLoading(false);
    } catch (e) {
      dispatch(actions.showNotice('Error', 4000));
    }
  };

  const moreButtonData = [
    // {
    //   title: `Duplicate`,
    //   clickHandler: copyHandler,
    // },
    {
      title: t('General.Delete'),
      clickHandler: isModificationGroup ? deleteModificationGroupHandler : deleteHandler,
      isDelete: true,
    },
  ];

  const renderForm = () => (
    <>
      <ModalHeader
        title={title}
        description={description}
        moreButtonData={idToUpdate ? moreButtonData : undefined}
      />
      {children}
    </>
  );

  return (
    <>
      {loading && (
        <LoaderWrapper
          onClick={(event) => {
            event.stopPropagation();
          }}>
          <Loader />
        </LoaderWrapper>
      )}
      <SideModal
        isOpen
        closeModal={closeModal}
        showUnsavedChangesQuestionModal={showUnsavedChangesQuestionModal}>
        {renderForm()}
      </SideModal>
    </>
  );
};

export default FormWrapper;
